import { propertyOf } from '../../utils/propertyOf';
import { CrudRouter, ParamType } from '../Routers/CrudRouter';
import { PPSCardMembershipRequestsTable } from './Table/PPSCardMembershipRequestsTable';

export const PPSCardMembershipRequestsRouter = () => {
	return (
		<CrudRouter
			ListComponent={PPSCardMembershipRequestsTable}
			paramName={propertyOf<ParamType>('id')}
		/>
	);
};
